import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 100+ AI PROMPTS FOR 911 DISPATCHERS™ (6 Volumes, 120 prompts)',
  price: '$54'
}, {
  label: '🎁 Bonus #1: THE 500+ CAD NOTE & NARRATIVE PHRASE BANK™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: THE CALL REVIEW SELF-AUDIT CHECKLIST™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: THE SHIFT PASS-DOWN & BRIEFING TEMPLATES™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #4: THE 12-HOUR SHIFT SURVIVAL PLANNER FOR DISPATCHERS™',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-269" data-mp="1tf3e7vpg690i">
      
    </section>;
}